<template>
  <div id="contenedor-contratos-estatus-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevoContratoEstatus="registrarNuevoContratoEstatus"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <listado :contratosEstatus="getContratosEstatus"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- CUADRO DE DIALOGO AGREGAR -->
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoContratoEstatus"
      :width="!$vuetify.breakpoint.xs ? '600' : '90%'">
      <registrar-nuevo-contrato-estatus
        v-if="mostrarVentanaRegistrarNuevoContratoEstatus"
        v-on:cerrar="cerrarVentana">
      </registrar-nuevo-contrato-estatus>
    </v-dialog>
    <!-- CUADRO DE DIALOGO EDITAR -->
    <v-dialog
    v-if="esteContratoEstatus"
      v-model="mostrarVentanaEditarContratoEstatus"
      :width="!$vuetify.breakpoint.xs ? '600' : '90%'">
      <editar-contrato-estatus
      :contratoEstatusEditar="esteContratoEstatus"
        v-on:cerrar="cerrarVentana">
      </editar-contrato-estatus>
    </v-dialog>
    <!-- CUADRO DE DIALOGO ELIMINAR -->
    <v-dialog
    v-if="esteContratoEstatus"
      v-model="mostrarVentanaEliminarContratoEstatus"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
      <eliminar-contrato-estatus
      :contratoEstatusEliminar="esteContratoEstatus"
        v-on:cerrar="cerrarVentana">
      </eliminar-contrato-estatus>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATOS_ESTATUS from '@/graphql/querys/administracion/catalogos/contratosestatus/contratosEstatus.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevoContratoEstatus from '@/components/administracion/configuracion/catalogos/contratoestatus/Nuevo.vue';
import EditarContratoEstatus from '@/components/administracion/configuracion/catalogos/contratoestatus/Editar.vue';
import EliminarContratoEstatus from '@/components/administracion/configuracion/catalogos/contratoestatus/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoEstatussDefault',
  components: {
    TituloToolBar,
    RegistrarNuevoContratoEstatus,
    EditarContratoEstatus,
    EliminarContratoEstatus,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoContratoEstatus: false,
      mostrarVentanaEditarContratoEstatus: false,
      mostrarVentanaEliminarContratoEstatus: false,
      esteContratoEstatus: null,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  mounted() {
    eventBus.$on('editar-contrato-estatus', (contratoEstatus) => {
      this.esteContratoEstatus = contratoEstatus;
      this.mostrarVentanaEditarContratoEstatus = true;
    });
    eventBus.$on('eliminar-contrato-estatus', (contratoEstatus) => {
      this.esteContratoEstatus = contratoEstatus;
      this.mostrarVentanaEliminarContratoEstatus = true;
    });
  },
  apollo: {
    contratosEstatus: {
      query: CONTRATOS_ESTATUS,
    },
  },
  methods: {
    registrarNuevoContratoEstatus() {
      this.mostrarVentanaRegistrarNuevoContratoEstatus = true;
    },
    cerrarVentana() {
      this.mostrarVentanaRegistrarNuevoContratoEstatus = false;
      this.mostrarVentanaEditarContratoEstatus = false;
      this.mostrarVentanaEliminarContratoEstatus = false;
      this.esteContratoEstatus = null;
    },
  },
  computed: {
    getContratosEstatus() {
      if (!this.contratosEstatus) return [];
      return this.contratosEstatus
      // Filtrar por Texto de Busqueda
        .filter((estatus) => {
          if (!this.filtros.buscarTexto) return estatus;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const nombre = this.$normalizacionTexto(estatus.nombre);
          return (
            expt.test(nombre)
            || expt.test(estatus.nombre)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
